module.exports = class CommentPlatform
{
  constructor({
    type,
    id,
    userId,
    name,
    commentId,
  }) {
    this.type = type;
    this.id = id;
    this.userId = userId;
    this.name = name;
    this.commentId = commentId;
  }

  get platformServiceId() {
    return this.type + '_' + this.id;
  }
};
